import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Toaster extends Vue {
  private toastCount: number = 0;
  private alertMsg: string = null;
  private alertType: string = null;

  public get toastMsg() {
    let res = false;
    if (
      this.$store.state.alertStore.alertMessage != null &&
      this.$store.state.alertStore.alertMessage != '' &&
      typeof this.$store.state.alertStore.alertMessage == 'string'
    ) {
      this.alertMsg = this.$store.state.alertStore.alertMessage;
      this.alertType = this.$store.state.alertStore.alertType;
      this.makeToast(true);
      res = true;
    }
    return res;
  }
  private makeToast(append = false) {
    this.toastCount++;
    let variant = 'info';
    let toastTitle = '';

    if (this.alertType == 'success') {
      variant = 'success';
      toastTitle = 'OK';
    } else if (this.alertType == 'danger' || this.alertType == 'error') {
      variant = 'danger';
      toastTitle = 'ERRORE';
    } else {
      variant = 'info';
      toastTitle = 'Info';
    }

    this.$bvToast.toast(this.alertMsg, {
      title: toastTitle,
      autoHideDelay: 3000,
      appendToast: append,
      variant: variant
    });
  }
}
